// packages/web/src/api/invites/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { invitesGet } from "../generated/sdk.gen.ts";
import { queryKeys } from "../query-keys.ts";

export const inviteByTokenOptions = (token: string) =>
  queryOptions({
    queryKey: queryKeys.invites.byToken(token),
    queryFn: async () => {
      const { data, error } = await invitesGet({ path: { token } });
      if (error) throw error;
      return data;
    },
    enabled: !!token,
  });
